import React from 'react';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import { Grid, List, ListItem, ListItemText, Typography } from '@material-ui/core';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CloseIcon from '@material-ui/icons/Close';

interface PasswordRequiredProps {
    oneLetter: boolean,
    oneNumber: boolean,
    oneCapitalLetter: boolean,
    eightCharacter: boolean,
    oneSpecialChar: boolean
}

interface RequirementMapTypes {
    has: boolean,
    innerHtml: string
}

const useStyles = makeStyles(() =>
    createStyles({
        red: {
            color: '#ec0502'
        },
        green: {
            color: '#45ae37'
        }
    })
);




export default function PasswordRequirements({
    oneLetter,
    oneNumber,
    oneCapitalLetter,
    eightCharacter,
    oneSpecialChar
}: PasswordRequiredProps) {
    const classes = useStyles();
    const requirements = [
        { has: oneLetter, innerHtml: "At least one lowercase letter" },
        { has: oneNumber, innerHtml: "At least one number" },
        { has: oneCapitalLetter, innerHtml: "At least one uppercase letter" },
        { has: eightCharacter, innerHtml: "Be at least 8 characters" },
        { has: oneSpecialChar, innerHtml: "At least one special character" },
    ]

    function iconType(valid: boolean) {
        return (
            valid ? <CheckCircleIcon className={classes.green + " mr10 "}/> : <CloseIcon className={classes.red + " mr10 "}/>
        )
    }

    return (
        <Grid container style={{backgroundColor: "#F5F8FD", padding: "1rem"}}>
            <Grid item xs={12}>
                <Typography variant="caption" component="strong" gutterBottom color="primary">
                    Password Requirements
                </Typography>
                <List style={{padding: 0}}>
                    {
                        requirements.map((row: RequirementMapTypes, index: number) => (
                            <ListItem key={index} style={{padding: 0}}>
                                {iconType(row.has)}
                                <ListItemText className="smallfont">{row.innerHtml}</ListItemText>
                            </ListItem>
                        ))
                    }
                </List>
            </Grid>
        </Grid>
    );
};
